export const sortArrayFullName = (a, b, property) => {
  const firstValue = a[property].split(' ')[1] ? a[property].split(' ')[1] : a[property].split(' ')[0];
  const secondValue = b[property].split(' ')[1] ? b[property].split(' ')[1] : b[property].split(' ')[0];
  return String(firstValue).localeCompare(String(secondValue), undefined, {
    numeric: true,
  });
};
